<!-- 快递转自提 -->
<template>
  <el-dialog
    title="订单转换"
    :visible.sync="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-form-item label="自提店铺" prop="shopId">
        <el-select
          v-model="form.shopId"
          reserve-keyword
          placeholder="请选择自提店铺"
          style="width:300px;"
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.shopName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-row type="flex" justify="end" style="margin-top: 45px;">
        <el-button
          class="standard-button"
          style="margin-right: 10px;"
          @click="handleClose"
          >取消</el-button
        >
        <el-button
          class="standard-button"
          type="primary"
          :loading="loading"
          @click="handlerConfirm"
          >确认</el-button
        >
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'SelectShopDialog',
  data() {
    return {
      form: {
        shopId: '',
      },
      rules: {
        shopId: [
          { required: true, message: '请选择自提店铺', trigger: 'change' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    handlerConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleClose() {
      this.resetForm();
      this.$emit('update:visible', false);
    },
  },
};
</script>
